import { createContext, useContext } from 'react';

export const ItineraryContext = createContext(null);

export const useItinerary = () => useContext(ItineraryContext);
